import { ReactElement, useMemo } from 'react';
import { DefaultTheme, useTheme } from 'styled-components';

import { Status as WaitlistEntryStatus } from '@dreryk/egabinet-waitlist-frontend-api';

import { Message, MessageOptions } from '@dreryk/react-components';

import { translationKeys } from '../../translations';

export enum WaitlistEntryStatusType {
   PENDING = 'PENDING',
   REGISTERED = 'REGISTERED',
   CONFIRMED = 'CONFIRMED',
   SUSPENDED = 'SUSPENDED',
   COMPLETED = 'COMPLETED',
   REMOVED = 'REMOVED',
}

const createAppointmentMessageOptions = (theme: DefaultTheme): MessageOptions<typeof WaitlistEntryStatusType> => ({
   PENDING: {
      color: theme.primary,
      backgroundColor: theme.primaryLighter,
   },
   CONFIRMED: {
      color: theme.success,
      backgroundColor: theme.successLighter,
   },
   SUSPENDED: {
      color: theme.error,
      backgroundColor: theme.errorLighter,
   },
   REGISTERED: {
      color: theme.warning,
      backgroundColor: theme.warningLighter,
   },
   COMPLETED: {
      color: theme.disabledDarker,
      backgroundColor: theme.disabledLighter,
   },
   REMOVED: {
      color: theme.disabledDarker,
      backgroundColor: theme.disabledLighter,
   },
});

type StatusCellProps = {
   readonly status: WaitlistEntryStatus;
};

const useOptions = (): MessageOptions<typeof WaitlistEntryStatusType> => {
   const theme = useTheme();
   return useMemo(() => createAppointmentMessageOptions(theme), [theme]);
};

export const StatusCell = (props: StatusCellProps): ReactElement => {
   const options = useOptions();

   return (
      <Message
         displayIndicator
         type={props.status}
         options={options}
         label={translationKeys.statusMap[props.status]}
         testId={'waitlistEntryStatus'}
      />
   );
};
